import { TFunction } from 'i18next';

export function mapCollectionType(collectionType: string, t: TFunction) {
    if (collectionType === 'INDIVIDUAL') {
        return t('individualCollection');
    } else if (collectionType === 'SHARED') {
        return t('sharedCollection');
    }
}

export function mapStatus(status: string, t: TFunction) {
    if (status === 'Active') {
        return t('components.epressCopiesPopup.active');
    } else {
        return t('components.epressCopiesPopup.expired');
    }
}
